import { render, staticRenderFns } from "./myMessage.vue?vue&type=template&id=7f357be8&scoped=true"
import script from "./myMessage.vue?vue&type=script&lang=js"
export * from "./myMessage.vue?vue&type=script&lang=js"
import style0 from "./myMessage.vue?vue&type=style&index=0&id=7f357be8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f357be8",
  null
  
)

export default component.exports